import { render, staticRenderFns } from "./JobMatchingWorkStyles.vue?vue&type=template&id=7b05bad4"
import script from "./JobMatchingWorkStyles.vue?vue&type=script&lang=js"
export * from "./JobMatchingWorkStyles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports